import { createRouter, createWebHashHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "share",
    component: () => import("./Promotion"),
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
});

export default router;
